var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.047.926H10.3c-1.629 0-2.954 1.339-2.954 2.984v4.768a.21.21 0 0 0 .207.21.208.208 0 0 0 .13-.046l2.408-1.95h2.955C14.675 6.893 16 5.555 16 3.91 16 2.265 14.675.926 13.047.926Zm0 5.548H8.706a.208.208 0 0 0-.208.21c0 .115.093.209.207.209h.723L7.76 8.243V3.91c0-1.414 1.14-2.565 2.54-2.565h2.746c1.4 0 2.54 1.15 2.54 2.565 0 1.413-1.14 2.564-2.54 2.564Z",
  fill: "#B18D3B",
  stroke: "#B18D3B",
  strokeWidth: 0.3
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.997 2.933H9.35a.208.208 0 0 0-.208.209c0 .116.093.21.208.21h4.647a.208.208 0 0 0 .207-.21.208.208 0 0 0-.207-.21ZM13.306 4.698H10.04a.208.208 0 0 0-.207.21c0 .115.092.209.207.209h3.266a.208.208 0 0 0 .208-.21.209.209 0 0 0-.208-.209Z",
  fill: "#B18D3B",
  stroke: "#B18D3B",
  strokeWidth: 0.3
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.958 9.901a.205.205 0 0 0-.268.002l-1.27 1.1c-.903-.81-1.534-2.342-1.586-3.848l1.455-.05a.208.208 0 0 0 .2-.186l.37-3.218a.21.21 0 0 0-.11-.21l-2.48-1.306a.206.206 0 0 0-.248.042A7.55 7.55 0 0 0 1 7.387c0 4.157 3.35 7.54 7.466 7.54.091 0 .172-.061.198-.15l.78-2.621a.21.21 0 0 0-.066-.222l-2.42-2.033Zm1.354 4.605c-3.818-.083-6.898-3.245-6.898-7.12 0-1.765.64-3.447 1.804-4.756L5.43 3.795l-.333 2.896-1.482.052a.209.209 0 0 0-.2.21c0 1.76.772 3.605 1.877 4.488.078.063.189.06.264-.005l1.271-1.1 2.18 1.831-.696 2.34Z",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.3
})));

export default SvgIconPhone;